<template>
    <div class="admin-shell" :class="{ 'admin-shell--page-scroll': scroll === 'page' }">

        <!-- Modais e âncoras de menu: irmãos da casca (position: fixed), fora da
             cadeia flex do painel. -->
        <slot name="modals"></slot>

        <NavBarLeftAdmin :path="path"></NavBarLeftAdmin>

        <!-- Onboardings Meta ao vivo: sempre visível em toda página do admin. -->
        <OnboardingAoVivoWidget />

        <div v-if="layout.mobileOpen" class="admin-sidebar-backdrop" @click="fecharMenu" aria-hidden="true"></div>

        <main class="admin-main">

            <HeaderPage :title="title" :subtitle="subtitle">
                <template v-if="$slots.actions" #actions>
                    <slot name="actions"></slot>
                </template>
            </HeaderPage>

            <div class="admin-page__body" :class="bodyClass">
                <div v-if="panel" class="admin-panel" :class="panelClass">
                    <slot></slot>
                </div>
                <slot v-else></slot>
            </div>

        </main>

    </div>
</template>

<script>
import NavBarLeftAdmin from './NavBarLeftAdmin.vue';
import HeaderPage from './HeaderPage.vue';
import OnboardingAoVivoWidget from '@/components/admin/meta-onboarding/OnboardingAoVivoWidget.vue';
import { adminLayoutState, fecharSidebarMobile } from './adminLayoutState';

/**
 * Casca padrão de TODA página do admin.
 *
 *   <AdminPage path="/admin-usuarios" title="Usuários" subtitle="…">
 *       <template #modals> …modais e âncoras… </template>
 *       <template #actions> <ButtonField … /> </template>
 *       …conteúdo (fica dentro do painel branco)…
 *   </AdminPage>
 *
 * Props de layout:
 * - `scroll`: `panel` (default) — a tela cabe na viewport e só as linhas da
 *   tabela rolam; `page` — a coluna de conteúdo rola inteira (relatórios).
 * - `panel`: envolve o conteúdo no cartão branco (`.admin-panel`). Páginas de
 *   relatório com vários cartões passam `:panel="false"`.
 *
 * O CSS da casca está em `assets/css/admin.css` (seção "Casca").
 */
export default {
    name: 'AdminPage',
    components: { NavBarLeftAdmin, HeaderPage, OnboardingAoVivoWidget },
    props: {
        /** Rota atual, para a lateral marcar o item ativo. */
        path: { type: String, required: true },
        title: { type: String, default: '' },
        subtitle: { type: String, default: '' },
        scroll: {
            type: String,
            default: 'panel',
            validator: (v) => ['panel', 'page'].includes(v),
        },
        panel: { type: Boolean, default: true },
        bodyClass: { type: [String, Array, Object], default: '' },
        panelClass: { type: [String, Array, Object], default: '' },
    },
    setup() {
        return { layout: adminLayoutState };
    },
    methods: {
        fecharMenu() {
            fecharSidebarMobile();
        },
    },
};
</script>
